export default "__VITE_ASSET__Bt3N9cKY__"